import { IPriceDeliveryInput } from 'generated/graphql-gateway';
import { IPriceOrderParams } from 'hooks/price-order/types';
import { ServiceMode } from 'state/service-mode/types';

export const buildPriceDeliveryInput = (
  order: Pick<
    IPriceOrderParams,
    | 'deliveryAddress'
    | 'orderPhoneNumber'
    | 'serviceMode'
    | 'tipCents'
    | 'deliveryInstructions'
    | 'customerPhoneNumber'
  >,
  quoteId: string
): IPriceDeliveryInput | null => {
  if (order.serviceMode !== ServiceMode.DELIVERY || !order.deliveryAddress) {
    return null;
  }

  const usersPhoneNumber = order.orderPhoneNumber || order.customerPhoneNumber || '';
  const phoneNumber = usersPhoneNumber.length === 10 ? `+1${usersPhoneNumber}` : usersPhoneNumber;

  return {
    dropoff: {
      ...order.deliveryAddress,
      phoneNumber,
    },
    instructions: order.deliveryInstructions,
    quoteId,
    tipCents: order.tipCents,
  };
};
